import { createSelector } from 'reselect'

export const makeSelectEmptySimsState = () => (state) => state.get('emptySims');
export const makseSelectFreeNumbersState = () => (state) => state.get('freeNumbers');

export const makeSelectReady = () => createSelector(
  makeSelectEmptySimsState(),
  (substate) => substate.get('ready')
);

export const makeSelectFetching = () => createSelector(
  makeSelectEmptySimsState(),
  (substate) => substate.get('fetching')
);

export const makeSelectEmptySims = () => createSelector(
  makeSelectEmptySimsState(),
  (substate) => substate.get('emptySims')
);

// FreeNumbers

export const makeSelectNumbersReady = () => createSelector(
  makeSelectEmptySimsState(),
  (substate) => substate.get('ready')
);

export const makeSelectNumbersFetching = () => createSelector(
  makeSelectEmptySimsState(),
  (substate) => substate.get('fetching')
);
export const makeSelectFreeNumbers = () => createSelector(
  makeSelectEmptySimsState(),
  (substate) => substate.get('freeNumbers')
);

export const makeSelectNewSubFinished = () => createSelector(
  makeSelectEmptySimsState(),
  (substate) => substate.get('newSubFinished')
);

export const makeSelectAbleToActivate = () => createSelector(
  makeSelectEmptySimsState(),
  (substate) => {
    const data = substate.get('ableToActivate');
    if (data !== null) {
      if (data === true) {
        return true
      }
      return data.toJS().data
    }
    return null
  }
);
